import type { ActionReducerMap } from '@ngrx/store';
import type { LoginState } from 'app/store/login/login.state';
import { assignedProjectsReducer } from 'app/store/login/assigned-projects/assigned-projects.reducer';
import { loggedUserReducer } from 'app/store/login/logged-user/logged-user.reducer';

export const loginReducer: ActionReducerMap<LoginState, any> = {
  assignedProjects: assignedProjectsReducer,
  loggedUser: loggedUserReducer,
};
